// Utilities for API endpoint
import axios from 'axios';
import environment from "../environments/production";
import { mobileAppUtil } from './mobileAppUtil';
var apis = {
  'mobile': {
    'develop': 'https://eus-rsg-9cd37598e2c0-xc2-dev-cm.azurewebsites.net',
    'development': 'https://eus-rsg-9cd37598e2c0-xc2-dev-cm.azurewebsites.net',
    'nptest': 'https://eus-rsg-xc2-nptest-95e51578df1-cm.azurewebsites.net',
    'npdev': 'https://eus-rsg-xc2-npdev-a87b640f0ea3-cm.azurewebsites.net',
    'qa': 'https://eus-rsg-2f9554755a64-xc3-qa-jsscd.azurewebsites.net',
    'stage': 'https://eus-rsg-be5d7e8c20d4-xc2-stg-jsscd.azurewebsites.net',
    'production': 'https://eus-rsg-0b952bdf5fa9-xc4-prd-jsscd.azurewebsites.net'
  },
  'server': {
    'local': '',
    'develop': '',
    'development': '',
    'nptest': '',
    'npdev': '',
    'qa': '',
    'stage': '',
    'production': ''
  }
};
var payPalIds = {
  'local': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'develop': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'development': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'nptest': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'npdev': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'qa': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'stage': 'AW8sKGy7Sov67MArCUZU5WMgdBklgN_l38TG8D0DD11HWCEFORZAvh-6y9j8hQ3txd0YlQyY47AyWK9w',
  'production': 'AVVNwrNtI2-gl_rOdElyjlJbXyex7IvSOU0kfsEedGB_j2a_5qxCYWLnO1152mwiNFL31wS2FAEVfpAA'
};
var crackerbarrelAPI = "/crackerbarrel/api";
var storeportalAPI = '/storeportal/api';
var mulesoftApiUrl = '/mulesoft/api';
var envUrl = apis["server"]["production"];
export var payPalClientId = payPalIds["production"];
var omniUrl = environment.omniUrl;
var vantivUrls = {
  'local': 'https://request.eprotect.vantivprelive.com',
  'develop': 'https://request.eprotect.vantivprelive.com',
  'development': 'https://request.eprotect.vantivprelive.com',
  'nptest': 'https://request.eprotect.vantivprelive.com',
  'npdev': 'https://request.eprotect.vantivprelive.com',
  'qa': 'https://request.eprotect.vantivprelive.com',
  'stage': 'https://request.eprotect.vantivprelive.com',
  'production': 'https://request.eprotect.vantivcnp.com'
};
var bonusGameUrls = {
  'local': 'https://crackerbarrel-rewards.review.eprize.com',
  'develop': 'https://crackerbarrel-rewards.review.eprize.com',
  'development': 'https://crackerbarrel-rewards.review.eprize.com',
  'nptest': 'https://crackerbarrel-rewards.review.eprize.com',
  'npdev': 'https://crackerbarrel-rewards.review.eprize.com',
  'qa': 'https://crackerbarrel-rewards.review.eprize.com',
  'stage': 'https://crackerbarrel-rewards.review.eprize.com',
  'production': 'https://crackerbarrel-rewards.promo.eprize.com'
};
var payPageIds = {
  'local': 'M96x8zaKhep2NTQ4',
  'develop': 'M96x8zaKhep2NTQ4',
  'development': 'M96x8zaKhep2NTQ4',
  'nptest': 'M96x8zaKhep2NTQ4',
  'npdev': 'M96x8zaKhep2NTQ4',
  'qa': 'M96x8zaKhep2NTQ4',
  'stage': 'M96x8zaKhep2NTQ4',
  'production': 'xpXuRhBm3VegACdJ'
};
var merchantIds = {
  'local': '4445047414388',
  'develop': '4445011410407',
  'development': '4445011410407',
  'nptest': '4445011410407',
  'npdev': '4445011410407',
  'qa': '4445047414388',
  'stage': '4445047414388',
  'production': '4445047414388'
};
var appleIds = {
  'local': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive'
  },
  'develop': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'development': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'nptest': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'npdev': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'qa': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'stage': {
    'payPageId': 'E9pAjyc7vMDNxrdC',
    'merchantId': 'merchant.com.crackerbarrel2.prelive',
    'tokenEnvironment': 'dev'
  },
  'production': {
    'payPageId': 'xpXuRhBm3VegACdJ',
    'merchantId': 'merchant.com.crackerbarrel.prod',
    'tokenEnvironment': 'prod'
  }
};
var googleIds = {
  'local': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'develop': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'development': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'nptest': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'npdev': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'qa': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'stage': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': '4445011410407'
  },
  'production': {
    'payPageId': 'u9mVmDz56FfeKdKc',
    'merchantId': '4445047431317'
  }
};
var googleIdsMobilePay = {
  'local': {
    'payPageId': 'oyZ9drQ3HsptbfL9',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'develop': {
    'payPageId': 'M96x8zaKhep2NTQ4',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'development': {
    'payPageId': 'M96x8zaKhep2NTQ4',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'nptest': {
    'payPageId': 'M96x8zaKhep2NTQ4',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'npdev': {
    'payPageId': 'M96x8zaKhep2NTQ4',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'qa': {
    'payPageId': 'M96x8zaKhep2NTQ4',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'stage': {
    'payPageId': 'oyZ9drQ3HsptbfL9',
    'merchantId': '4445011410407',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'TEST'
  },
  'production': {
    'payPageId': 'tU4oV6QD2Xh3PsCt',
    'merchantId': 'BCR2DN6TW6Y555DD',
    'merchantReportGroup': 'pay_at_table',
    'environment': 'PRODUCTION'
  }
};
var googleWebPayInfo = {
  'gateway': process.env.REACT_APP_GOOGLE_PAY_WEB_GATEWAY,
  'gatewayMerchantId': process.env.REACT_APP_GOOGLE_PAY_WEB_GATEWAY_MERCHANT_ID,
  'environment': process.env.REACT_APP_GOOGLE_PAY_WEB_ENVIRONMENT,
  'merchantId': process.env.REACT_APP_GOOGLE_PAY_WEB_MERCHANT_ID
};
var appleWebPayInfo = {
  'merchantId': process.env.REACT_APP_APPLE_PAY_WEB_MERCHANT_ID
};
export var apiUtil = {
  /**
   * Generates the proper API endpoint based on environment
   *
   * @param {String} service
   * @param {String} endpoint
   */
  generateUrl: function generateUrl(service, endpoint) {
    if (typeof service === "undefined") {
      return "";
    }

    var path = environment.apiEndpoints[service][endpoint];
    return "".concat(environment.apiUrl, "/").concat(service, "/").concat(environment.apiVersion, "/").concat(path);
  },

  /**
  * Generates the proper API endpoint based on environment
  *
  * @param {String} service
  * @param {String} endpoint
  */
  generateUrlForceVersion: function generateUrlForceVersion(service, endpoint, version) {
    if (typeof service === "undefined") {
      return "";
    }

    var path = environment.apiEndpoints[service][endpoint];
    return "".concat(environment.apiUrl, "/").concat(service, "/").concat(version, "/").concat(path);
  },
  setHeaders: function setHeaders() {
    return {
      // 'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/json",
      // 'Ocp-Apim-Trace':'true',
      "Ocp-Apim-Subscription-Key": environment.apiSubscription
    };
  },
  setHeadersB2C: function setHeadersB2C() {
    return {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": environment.apiSubscriptionB2C
    };
  },
  fetchPost: function fetchPost(url, data, authToken) {
    var options = data ? JSON.stringify(data) : undefined;
    var headers = {
      "Content-Type": "application/json"
    };

    if (authToken) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    return axios.post(url, options, {
      withCredentials: true,
      headers: headers
    }).then(function (json) {
      if (json.data.Success === false) {
        throw json.data;
      } else {
        return json.data;
      }
    });
  },
  fetchDelete: function fetchDelete(url, data, authToken) {
    var options = data ? JSON.stringify(data) : undefined;
    var headers = {
      "Content-Type": "application/json"
    };

    if (authToken) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    var config = {
      data: options,
      withCredentials: true,
      headers: headers
    };
    return axios.delete(url, config).then(function (json) {
      if (json.data.Success === false) {
        throw json.data;
      } else {
        return json.data;
      }
    });
  },
  fetchPatch: function fetchPatch(url, data, authToken) {
    var body = data ? JSON.stringify(data) : undefined;
    var headers = {
      "Content-Type": "application/json"
    };

    if (authToken) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    var config = {
      withCredentials: true,
      headers: headers
    };
    return axios.patch(url, body, config).then(function (json) {
      if (json.data.Success === false) {
        throw json.data;
      } else {
        return json.data;
      }
    });
  },
  fetchGet: function fetchGet(url, authToken) {
    var headers = {
      "Content-Type": "application/json",
      "access-control-allow-origin": "*"
    };

    if (authToken) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    var config = {
      headers: headers
    };

    if (mobileAppUtil.isMobileApp() && (url === null || url === void 0 ? void 0 : url.includes("/crackerbarrel/api/products/get/wishlist"))) {
      config.withCredentials = true;
    }

    return axios.get(url, config).then(function (json) {
      if (json.data.Success === false) {
        throw json.data;
      } else {
        return json.data;
      }
    });
  },
  API: {
    baseUrl: envUrl,
    postAccount: "".concat(envUrl).concat(crackerbarrelAPI, "/federatedauthentication/registerandlogin"),
    postStoreAccount: "".concat(envUrl).concat(storeportalAPI, "/authorize"),
    getOloCurbside: "".concat(envUrl).concat(crackerbarrelAPI, "/order/customer-arrival-notification"),
    getProduct: "".concat(envUrl).concat(crackerbarrelAPI, "/product/get"),
    getMenu: "".concat(envUrl).concat(crackerbarrelAPI, "/products/get"),
    getFeatures: "".concat(envUrl).concat(crackerbarrelAPI, "/products/get/featured"),
    getUpsell: "".concat(envUrl).concat(crackerbarrelAPI, "/products/get/upsellcard"),
    getArticles: "".concat(envUrl).concat(crackerbarrelAPI, "/articles/get"),
    getSearch: "".concat(envUrl).concat(crackerbarrelAPI, "/get/searchresults"),
    getCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/get"),
    postCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/add"),
    updateCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/update"),
    deleteCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/delete"),
    setDelivery: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliverymode/set"),
    setPromoCode: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/promocode/apply"),
    deletePromoCode: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/promocode/delete"),
    setTimeWanted: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/timewanted"),
    setTip: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/tip"),
    getDeliveryModes: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliverymodes"),
    setCustomFields: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/customfields/set"),
    setDeliveryAddress: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliveryaddress/set"),
    validateCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/validate"),
    submitCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/v2/checkout"),
    getWishlist: "".concat(envUrl).concat(crackerbarrelAPI, "/products/get/wishlist?storeId={storeId}"),
    addWishlist: "".concat(envUrl).concat(crackerbarrelAPI, "/wishlist/add"),
    removeWishlist: "".concat(envUrl).concat(crackerbarrelAPI, "/wishlist/delete"),
    emailCatering: "".concat(envUrl).concat(crackerbarrelAPI, "/emails/catering"),
    emailNewsroom: "".concat(envUrl).concat(crackerbarrelAPI, "/emails/newsroom"),
    emailMeals: "".concat(envUrl).concat(crackerbarrelAPI, "/emails/meals"),
    getAccountOrders: "".concat(envUrl).concat(crackerbarrelAPI, "/order/OrdersByCustomer"),
    reOrder: "".concat(envUrl).concat(crackerbarrelAPI, "/order/ReOrder"),
    addLineFromOrder: "".concat(envUrl).concat(crackerbarrelAPI, "/order/AddLineFromOrder"),
    getProductId: "".concat(envUrl).concat(crackerbarrelAPI, "/product/get/id?location={location}&productUrl={productUrl}"),
    cart: {
      //This is part of a refactor I want to do hence the double up
      getCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/get"),
      postCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/add"),
      postLoyaltyData: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/setloyaltydata"),
      updateCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/update"),
      deleteCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/delete"),
      setDelivery: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliverymode/set"),
      setPromoCode: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/promocode/apply"),
      deletePromoCode: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/promocode/delete"),
      setTimeWanted: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/timewanted"),
      setTip: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/tip"),
      getDeliveryModes: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliverymodes"),
      setCustomFields: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/customfields/set"),
      setDeliveryAddress: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/deliveryaddress/set"),
      validateCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/validate"),
      submitCart: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/checkout"),
      deleteAll: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/delete/all"),
      //request body is storeId
      getSchemaNumber: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/billingschemes"),
      getShippingMethods: "".concat(envUrl).concat(crackerbarrelAPI, "/checkout/getShippingMethods"),
      setShippingMethods: "".concat(envUrl).concat(crackerbarrelAPI, "/checkout/setShippingMethods"),
      getUnvabilableTimeslots: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/food/getunavailabletimeslots"),
      getgiftcardbalance: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/getgiftcardbalance"),
      removeTipAndEntitlements: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/removeTipAndEntitlements")
    },
    worldPay: {
      getSavedCards: "".concat(envUrl).concat(crackerbarrelAPI, "/user/savedcards"),
      giftCardBalance: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/giftcardbalance")
    },
    retail: {
      getCategories: "".concat(envUrl).concat(crackerbarrelAPI, "/retail/get/categories"),
      getRetail: "".concat(envUrl).concat(crackerbarrelAPI, "/retail/get/products"),
      getDetail: "".concat(envUrl).concat(crackerbarrelAPI, "/retail/get/product")
      /*?ctg=1062&s=title&sd=Desc*/

    },
    location: {
      getLocationSearch: "".concat(envUrl).concat(crackerbarrelAPI, "/get/locatorsearch"),
      getVendorid: "".concat(envUrl).concat(crackerbarrelAPI, "/get/vendorsearch"),
      getZipcodeSearch: "".concat(envUrl).concat(crackerbarrelAPI, "/get/zipcode"),
      getLocationByStoreNumber: "".concat(envUrl).concat(crackerbarrelAPI, "/get/storenumber")
    },
    commerce: {
      guestOrderCheck: "".concat(envUrl).concat(crackerbarrelAPI, "/commerce/guestorder"),
      updateGuestOrderStatus: "".concat(envUrl).concat(crackerbarrelAPI, "/order/UpdateGuestOrderStatus")
      /*?ctg=1062&s=title&sd=Desc*/

    },
    offline: {
      // getOrders: `http://crackerbarrel.dev.local${crackerbarrelAPI}/commerce/orders?startIndex=0&pageSize=13&sortBy=1&orderStatus=Completed&startDate=07272021T01:00:00&endDate=07272021T23:55:00`,
      getOrders: "".concat(envUrl).concat(crackerbarrelAPI, "/commerce/orders?sortBy=1&startIndex="),
      getShops: "".concat(envUrl).concat(crackerbarrelAPI, "/retail/get/products"),
      getCustList: "".concat(envUrl).concat(crackerbarrelAPI, "/commerce/users/get?index=0&pageSize=5&userName="),
      assignCustomer: "".concat(envUrl).concat(crackerbarrelAPI, "/cart/mergecart"),
      authorize: "".concat(envUrl).concat(storeportalAPI, "/authorize")
    },
    mobilepay: {
      getOrder: "".concat(omniUrl, "/ExternalPayments/Service.svc/OrderQuery"),
      payOrder: "".concat(omniUrl, "/ExternalPayments/Service.svc/PayOrder")
    },
    loyalty: {
      logIn: "".concat(envUrl).concat(crackerbarrelAPI, "/loyalty/login"),
      signUp: "".concat(envUrl).concat(crackerbarrelAPI, "/loyalty/enroll"),
      getRewardsAndCoupons: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?email={email}&include=rewards,coupons"),
      getPegPoints: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?email={email}"),
      getBonusRewards: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?email={email}&include=detail,coupons"),
      getPegPointsModule: "".concat(envUrl).concat(crackerbarrelAPI, "/loyalty/points"),
      getPegPointsModuleAuth: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/points/{email}"),
      getOrderPegPoints: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts/events?type=purchase&include=event_attributes,products&email={email}"),
      patchMyAccount: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?email={email}&action=update"),
      getMenuItemPegPoints: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/points?productChainId={productChainId}"),
      getAccountDetails: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?email={email}&include=detail,event_summary"),
      postAccountDetails: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts?include=detail"),
      postRewardsRedemption: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts/points"),
      getMissingPegPoints: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts/events?email={email}&orderNumber={orderNumber}"),
      getAccountEvents: "".concat(envUrl).concat(mulesoftApiUrl, "/v1/loyalty/customers/accounts/events?include=products,event_attributes,related_event,coupons,tenders")
    }
  }
};
export var vantivUrl = vantivUrls["production"];
export var merchantId = merchantIds["production"];
export var payPageId = payPageIds["production"];
export var appleId = appleIds["production"];
export var googleIdMobilePay = googleIdsMobilePay["production"];
export var googleWebPay = googleWebPayInfo;
export var appleWebPay = appleWebPayInfo;
export var tokenExIframeUrl = environment.tokenExIframe;
export var tokenExID = environment.tokenExId;
export var bonusGameUrl = bonusGameUrls["production"];